import React, { FunctionComponent, PropsWithChildren } from 'react';

export const EmptyLayout: FunctionComponent<PropsWithChildren<{}>> = ({
  children,
}) => {
  return (
    <div className="flex">
      <div className="flex-1 border-t-2 border-dashed border-red" />
      <div className="flex-1 border-l-2 border-b-2 border-dashed border-red text-center p-xl">
        {children}
      </div>
      <div className="flex-1 flex flex-col">
        <div className="flex-1" />
        <div className="h-popup border-l-2 border-t-2 border-dashed border-red w-full" />
      </div>
    </div>
  );
};
